"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _core2 = require("@stt-componentes/core");
var _coreV = require("@stt-componentes/core-v2");
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _AccessibilityNew = _interopRequireDefault(require("@material-ui/icons/AccessibilityNew"));
var _OpenInNew = _interopRequireDefault(require("@material-ui/icons/OpenInNew"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var rotulosIndicadores = {
  pesoIdade: 'Peso por idade',
  estaturaIdade: 'Estatura por idade',
  pesoEstatura: 'Peso por estatura',
  imc: 'IMC'
};
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    botaoEstado: {
      marginBottom: theme.spacing(1),
      alignSelf: 'flex-start',
      marginLeft: 1,
      padding: 18
    },
    container: {
      backgroundColor: '#e9f5fd',
      borderRadius: theme.shape.borderRadius,
      marginTop: theme.spacing(1),
      padding: theme.spacing(2),
      width: '100%',
      boxSizing: 'border-box'
    },
    externalIcon: {
      fontSize: '1rem',
      marginLeft: theme.spacing(0.5)
    },
    fonteLink: _objectSpread(_objectSpread({}, theme.typography.body2), {}, {
      alignItems: 'center',
      color: theme.palette.text.secondary,
      display: 'flex',
      marginTop: theme.spacing(0.25),
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }),
    fontesTitulo: _objectSpread(_objectSpread({}, theme.typography.body2), {}, {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(0.5)
    }),
    indicador: _objectSpread(_objectSpread({}, theme.typography.body2), {}, {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold
    }),
    tabela: {
      borderCollapse: 'collapse'
    },
    td: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      padding: theme.spacing(1)
    },
    th: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      padding: theme.spacing(1),
      textAlign: 'left'
    }
  };
});
var SENTINELA = 9007199254740991;
var formatIntervalo = function formatIntervalo(valor, intervalo) {
  if (intervalo) return intervalo;
  if (Math.abs(valor) === SENTINELA) return '—';
  return valor !== null && valor !== void 0 ? valor : '—';
};
var SelecaoEstadoNutricional = function SelecaoEstadoNutricional(_ref) {
  var grupo = _ref.grupo,
    indicadores = _ref.indicadores,
    strings = _ref.strings,
    open = _ref.open,
    setOpen = _ref.setOpen,
    classificacaoNutri = _ref.classificacaoNutri;
  var menorDeIdade = grupo === 'Criança' || grupo === 'Adolescente';
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
    type: "button",
    variant: "outlined",
    color: "secondary",
    className: classes.botaoEstado,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement(_AccessibilityNew["default"], {
    fontSize: "small"
  }), (strings === null || strings === void 0 ? void 0 : strings.estadoNutricional) || 'Estado Nutricional', open ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)), open && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttHidden, {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_coreV.SttTable, {
    size: "small",
    className: classes.tabela
  }, /*#__PURE__*/_react["default"].createElement(_coreV.SttTableHead, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttTableRow, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }), menorDeIdade ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Intervalo percentil"), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Diagn\xF3stico (percentil)"), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Intervalo Escore\u2011Z"), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Diagn\xF3stico (Escore\u2011Z)")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (classificacaoNutri === null || classificacaoNutri === void 0 ? void 0 : classificacaoNutri.imc) && /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Valor"), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Intervalo de refer\xEAncia"), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
    className: classes.th
  }, "Diagn\xF3stico")))), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableBody, null, Object.entries(indicadores).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      criterio = _ref3[0],
      dado = _ref3[1];
    return /*#__PURE__*/_react["default"].createElement(_coreV.SttTableRow, {
      key: criterio
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      component: "th",
      scope: "row",
      className: "".concat(classes.td, " ").concat(classes.indicador)
    }, (strings === null || strings === void 0 ? void 0 : strings[criterio]) || rotulosIndicadores[criterio] || criterio), menorDeIdade ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, formatIntervalo(dado === null || dado === void 0 ? void 0 : dado.valorPercentil, dado === null || dado === void 0 ? void 0 : dado.intervaloPercentil)), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, (dado === null || dado === void 0 ? void 0 : dado.classificacaoPercentil) || '—'), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, formatIntervalo(dado === null || dado === void 0 ? void 0 : dado.valorEscoreZ, dado === null || dado === void 0 ? void 0 : dado.intervaloEscoreZ)), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, (dado === null || dado === void 0 ? void 0 : dado.classificacaoEscoreZ) || '—')) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (classificacaoNutri === null || classificacaoNutri === void 0 ? void 0 : classificacaoNutri.imc) && /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, classificacaoNutri.imc), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, formatIntervalo(dado.valorReferencial, dado.intervaloReferencial)), /*#__PURE__*/_react["default"].createElement(_coreV.SttTableCell, {
      className: classes.td
    }, (dado === null || dado === void 0 ? void 0 : dado.classificacao) || (dado === null || dado === void 0 ? void 0 : dado.classificacaoPercentil) || (dado === null || dado === void 0 ? void 0 : dado.classificacaoEscoreZ) || '—')));
  })))), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_coreV.SttText, {
    className: classes.fontesTitulo
  }, (strings === null || strings === void 0 ? void 0 : strings.fontes) || 'Fontes'), /*#__PURE__*/_react["default"].createElement(_coreV.SttLink, {
    href: "https://www.gov.br/saude/pt-br/composicao/saps/vigilancia-alimentar-e-nutricional/arquivos/orientacoes-para-a-coleta-e-analise-de-dados-antropometricos-em-servicos-de-saude",
    target: "_blank",
    rel: "noopener",
    className: classes.fonteLink
  }, (strings === null || strings === void 0 ? void 0 : strings.orientacoesColeta) || 'Orientações para coleta e análise de dados antropométricos em serviços de saúde', /*#__PURE__*/_react["default"].createElement(_OpenInNew["default"], {
    className: classes.externalIcon
  })), /*#__PURE__*/_react["default"].createElement(_coreV.SttLink, {
    href: "https://www.gov.br/saude/pt-br/composicao/saps/vigilancia-alimentar-e-nutricional/parametros-para-avaliacao-nutricional",
    target: "_blank",
    rel: "noopener",
    className: classes.fonteLink
  }, (strings === null || strings === void 0 ? void 0 : strings.parametrosAvaliacao) || 'Parâmetros para avaliação nutricional', /*#__PURE__*/_react["default"].createElement(_OpenInNew["default"], {
    className: classes.externalIcon
  })))));
};
var _default = exports["default"] = SelecaoEstadoNutricional;